import LockIcon from '@mui/icons-material/Lock';
import React from 'react';

const LockedCellRenderer = (props: any) => {
    return props.value || props.value === 'true' ? <LockIcon /> : null;
};

export default LockedCellRenderer;
